import React from "react";
import { Button } from "antd";

/**
 * Site-wide icon action control.
 * Renders a borderless icon button with rounded grey hover/focus/active highlight
 * (styled globally via `.ui-action-icon` in App.css).
 */
const ActionIconButton = ({ className = "", style, children, ...props }) => (
  <Button
    type="text"
    className={`ui-action-icon${className ? ` ${className}` : ""}`}
    style={style}
    {...props}
  >
    {children}
  </Button>
);

export default ActionIconButton;
